export const screenBreakpoints = {
  xl: 1536,
  lg: 1200,
  md: 900,
  sm: 600,
  xs: 0,
};
